/* eslint semi:0 */
import { BaseStore } from './baseStore'
import { TYPES as MODAL_TYPES } from '../actions/modalActions'
import { empty as emptyComponent } from '../../utils/component'
import { TYPES as TOOLBAR_TYPES } from '../actions/userToolbarActions'
import { TYPES as SOCIAL_BUTTONS_TYPES } from '../actions/socialButtonsActions'
import signupModalComponent from '../components/signupModalComponent'
import embedCodeModalComponent from '../components/embedCodeModalComponent'

export default class ModalStore extends BaseStore {
  constructor(options = {}) {
    super(options)
    this.merge(options)
  }

  routeAction(action) {
    let { EMBED_OPEN } = SOCIAL_BUTTONS_TYPES
    let { NEW_USER_AUTHENTICATED } = TOOLBAR_TYPES
    switch (action.type) {
      case EMBED_OPEN:
        return this.openEmbedModal()
      case MODAL_TYPES.CLOSE:
        return this.closeModal()
      case NEW_USER_AUTHENTICATED:
        return this.openSignupModal({
          authId: action.authId,
          modalData: action.signupModalData,
        })
      default:
        return {}
    }
  }

  get currentComponent() {
    return this.state.currentComponent || emptyComponent
  }
  set currentComponent(componentFn) {
    this.state.currentComponent = componentFn || emptyComponent
  }

  openEmbedModal() {
    return this.merge({
      isModalOpen: true,
      currentComponent: embedCodeModalComponent,
    }).emitChange()
  }

  closeModal() {
    return this.merge({
      isModalOpen: false,
      currentComponent: null,
    }).emitChange()
  }

  openSignupModal(options) {
    return this.merge({
      isModalOpen: true,
      currentComponent: signupModalComponent.part(options),
    }).emitChange()
  }

  get isModalOpen() {
    return this.state.isModalOpen
  }
  set isModalOpen(isOpen) {
    this.state.isModalOpen = isOpen
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/ModalStore.js